import Select from 'react-select';

const CustomSelect = (props: any) => {
  // const val = props?.options?.filter((item: any) => {
  //   if (!props.value) return null;
  //   if (typeof props.value === 'number') return props?.value == item;
  //   // return props?.value?.includes(item?.value.toString());
  // });

  return (
    <div className={props.containerClassName ?? 'mt-3 col-lg-4 col-md-6 mb-2'}>
      {props.label && (
        <label htmlFor="fname-field" className="form-label">
          {props.label}
        </label>
      )}
      <Select
        style={{ zIndex: 1000 }}
        {...props}
        value={
          props.isMulti
            ? props?.options &&props?.options?.filter((item: any) => props?.value?.includes(item?.value?.toString()))
            : props?.options?.find(
                (item: any) => item.value?.toString() === props.value?.toString()
              ) ?? null
        }
        onChange={(value: any) => {
          if (props.isMulti) {
            props.onChange(value.map((item: any) => item.value));
          } else {
            props.onChange(value.value);
          }
        }}
        styles={{
          menu: (base) => ({
            ...base,
            zIndex: 100
          })
        }}
      />
    </div>
  );
};

export default CustomSelect;
